import Scorm2004API from '../Scorm2004API';

window.Scorm2004API = Scorm2004API;
